import inherited from 'mastodon/locales/uk.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
